import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import trackButton from '../actions/track-button';
import { buildHandleEnterKeyPress } from '../utils/accessibility';

const Button = ({
  children,
  disabled,
  dispatch,
  href,
  inverse,
  name,
  onClick,
  step,
  className,
}) => {
  const childrenComponents =
    typeof children === 'string' ? (
      <span className="button-text">{children}</span>
    ) : (
      children
    );

  const onClickHandler = () => {
    dispatch(trackButton({ disabled, name, step }));
    if (!disabled) {
      onClick();
    }
  };

  return (
    <LinkButton
      className={className}
      data-cy={`button-${disabled ? 'disabled' : 'enabled'}`}
      disabled={disabled}
      href={href}
      inverse={inverse}
      onClick={onClickHandler}
      onKeyPress={buildHandleEnterKeyPress(onClickHandler)}
      tabIndex={0}
    >
      {childrenComponents}
    </LinkButton>
  );
};

Button.propTypes = {
  disabled: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  inverse: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func,
  step: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

Button.defaultProps = {
  disabled: false,
  inverse: false,
  onClick: () => {},
  style: {},
};

const LinkButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  cursor: pointer;
  background-color: ${props => props.theme.primary};
  color: ${props => props.theme.buttonText};
  border: 0px solid transparent;
  border-radius: 4px;
  font-weight: 200;
  padding: 0.75em 1em;
  user-select: none;
  font-size: 1.2em;

  ${props => {
    if (props.disabled) {
      return `
        cursor: not-allowed;
        background-color: ${props.theme.border};
      `;
    }
  }}

  ${props => {
    if (props.inverse) {
      return `
        background-color: ${props.theme.background};
        color: ${props.theme.primary};
        border: 1px solid ${props.theme.primary};
        &:active {
          background-color: ${props.theme.lighterButtonColor}
          border-color: ${props.theme.buttonColor};
          box-shadow: 0 1px 6px 1px ${props.theme.border};
          border-bottom: ${`1px solid ${props.theme.shadow}`}!important;
          outline: none;
        }
      `;
    }
  }}

  &:hover {
    box-shadow: ${props => props.theme.shadow};
  }

  &.outlined {
    background-color: ${props => props.theme.background};
    font-size: 1.1em;
    color: ${props => props.theme.primary} !important;
    &:hover {
      background: ${props => props.theme.buttonColor};
      color: ${props => props.theme.buttonText} !important;
    }
  }

  .button-text {
    text-align: center;
    width: 100%;
  }
`;

export default connect()(Button);
